import React from 'react';

function EventsIcon({ width = 24, height = 24, color = '#2C3142', ...props }) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect x="3" y="4" width="18" height="16" rx="3" ry="3" stroke={color} strokeWidth="1.7" fill="none" />
            <path d="M8 2v4M16 2v4" stroke={color} strokeWidth="1.7" strokeLinecap="round" />
            <path d="M3 9h18" stroke={color} strokeWidth="1.7" />
            <path d="M9.5 13.5l1.2 1.2 2.8-2.8" stroke={color} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export default EventsIcon;
